import React from "react";
import { Field } from "../config/companies/config";
import FieldDisplay from "./FieldDisplay";

type DetailsDisplayProps = {
  field: Field;
  value: any;
  onChange: (fieldName: string, newValue: any) => void;
  item?: any;
};

const DetailsDisplay = ({
  field,
  value,
  onChange,
  item,
}: DetailsDisplayProps) => {
  return (
    <FieldDisplay field={field} value={value} onChange={onChange} item={item} />
  );
};

export default DetailsDisplay;
